// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"711448a8","703":"b71bacf6","787":"d1d4a2c2"}[chunkId] + ".chunk.js";
};